// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as PublicIndexRouteImport } from './routes/_public.index'
import { Route as PublicVendeTuPropiedadRouteImport } from './routes/_public.vende-tu-propiedad'
import { Route as PublicAgenteRouteImport } from './routes/_public.agente'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as PublicProyectosIndexRouteImport } from './routes/_public.proyectos.index'
import { Route as PublicBlogIndexRouteImport } from './routes/_public.blog.index'
import { Route as PublicProyectosSlugRouteImport } from './routes/_public.proyectos.$slug'
import { Route as PublicPropiedadSlugRouteImport } from './routes/_public.propiedad.$slug'
import { Route as PublicBlogSlugRouteImport } from './routes/_public.blog.$slug'
import { Route as PublicOperationTypeRouteImport } from './routes/_public.$operation.$type'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin.index'
import { Route as AuthenticatedAdminZubaRouteImport } from './routes/_authenticated/admin.zuba'
import { Route as AuthenticatedAdminTareasRouteImport } from './routes/_authenticated/admin.tareas'
import { Route as AuthenticatedAdminPerfilRouteImport } from './routes/_authenticated/admin.perfil'
import { Route as AuthenticatedAdminInfluencerRouteImport } from './routes/_authenticated/admin.influencer'
import { Route as AuthenticatedAdminCrmRouteImport } from './routes/_authenticated/admin.crm'
import { Route as AuthenticatedAdminContactosRouteImport } from './routes/_authenticated/admin.contactos'
import { Route as AuthenticatedAdminCalculadoraRouteImport } from './routes/_authenticated/admin.calculadora'
import { Route as AuthenticatedAdminBusquedasRouteImport } from './routes/_authenticated/admin.busquedas'
import { Route as AuthenticatedAdminBlogRouteImport } from './routes/_authenticated/admin.blog'
import { Route as PublicOperationTypeIndexRouteImport } from './routes/_public.$operation.$type.index'
import { Route as PublicOperationTypeLocationRouteImport } from './routes/_public.$operation.$type.$location'
import { Route as AuthenticatedAdminPropiedadesIndexRouteImport } from './routes/_authenticated/admin.propiedades.index'
import { Route as AuthenticatedAdminPropiedadesNuevaRouteImport } from './routes/_authenticated/admin.propiedades.nueva'
import { Route as AuthenticatedAdminPropiedadesIdRouteImport } from './routes/_authenticated/admin.propiedades.$id'
import { Route as AuthenticatedAdminBlogIndexRouteImport } from './routes/_authenticated/admin.blog.index'
import { Route as AuthenticatedAdminBlogNuevoRouteImport } from './routes/_authenticated/admin.blog.nuevo'
import { Route as AuthenticatedAdminBlogIdRouteImport } from './routes/_authenticated/admin.blog.$id'

const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const PublicRoute = PublicRouteImport.update({
            id: '/_public',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const PublicIndexRoute = PublicIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicRoute
          })
const PublicVendeTuPropiedadRoute = PublicVendeTuPropiedadRouteImport.update({
            id: '/vende-tu-propiedad',path: '/vende-tu-propiedad',getParentRoute: () => PublicRoute
          })
const PublicAgenteRoute = PublicAgenteRouteImport.update({
            id: '/agente',path: '/agente',getParentRoute: () => PublicRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const PublicProyectosIndexRoute = PublicProyectosIndexRouteImport.update({
            id: '/proyectos/',path: '/proyectos/',getParentRoute: () => PublicRoute
          })
const PublicBlogIndexRoute = PublicBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => PublicRoute
          })
const PublicProyectosSlugRoute = PublicProyectosSlugRouteImport.update({
            id: '/proyectos/$slug',path: '/proyectos/$slug',getParentRoute: () => PublicRoute
          })
const PublicPropiedadSlugRoute = PublicPropiedadSlugRouteImport.update({
            id: '/propiedad/$slug',path: '/propiedad/$slug',getParentRoute: () => PublicRoute
          })
const PublicBlogSlugRoute = PublicBlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => PublicRoute
          })
const PublicOperationTypeRoute = PublicOperationTypeRouteImport.update({
            id: '/$operation/$type',path: '/$operation/$type',getParentRoute: () => PublicRoute
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminZubaRoute = AuthenticatedAdminZubaRouteImport.update({
            id: '/zuba',path: '/zuba',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminTareasRoute = AuthenticatedAdminTareasRouteImport.update({
            id: '/tareas',path: '/tareas',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPerfilRoute = AuthenticatedAdminPerfilRouteImport.update({
            id: '/perfil',path: '/perfil',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminInfluencerRoute = AuthenticatedAdminInfluencerRouteImport.update({
            id: '/influencer',path: '/influencer',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminCrmRoute = AuthenticatedAdminCrmRouteImport.update({
            id: '/crm',path: '/crm',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminContactosRoute = AuthenticatedAdminContactosRouteImport.update({
            id: '/contactos',path: '/contactos',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminCalculadoraRoute = AuthenticatedAdminCalculadoraRouteImport.update({
            id: '/calculadora',path: '/calculadora',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBusquedasRoute = AuthenticatedAdminBusquedasRouteImport.update({
            id: '/busquedas',path: '/busquedas',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBlogRoute = AuthenticatedAdminBlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => AuthenticatedAdminRoute
          })
const PublicOperationTypeIndexRoute = PublicOperationTypeIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicOperationTypeRoute
          })
const PublicOperationTypeLocationRoute = PublicOperationTypeLocationRouteImport.update({
            id: '/$location',path: '/$location',getParentRoute: () => PublicOperationTypeRoute
          })
const AuthenticatedAdminPropiedadesIndexRoute = AuthenticatedAdminPropiedadesIndexRouteImport.update({
            id: '/propiedades/',path: '/propiedades/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPropiedadesNuevaRoute = AuthenticatedAdminPropiedadesNuevaRouteImport.update({
            id: '/propiedades/nueva',path: '/propiedades/nueva',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPropiedadesIdRoute = AuthenticatedAdminPropiedadesIdRouteImport.update({
            id: '/propiedades/$id',path: '/propiedades/$id',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBlogIndexRoute = AuthenticatedAdminBlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminBlogRoute
          })
const AuthenticatedAdminBlogNuevoRoute = AuthenticatedAdminBlogNuevoRouteImport.update({
            id: '/nuevo',path: '/nuevo',getParentRoute: () => AuthenticatedAdminBlogRoute
          })
const AuthenticatedAdminBlogIdRoute = AuthenticatedAdminBlogIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedAdminBlogRoute
          })





const AuthenticatedAdminBlogRouteChildren = {
  AuthenticatedAdminBlogIdRoute: AuthenticatedAdminBlogIdRoute,AuthenticatedAdminBlogNuevoRoute: AuthenticatedAdminBlogNuevoRoute,AuthenticatedAdminBlogIndexRoute: AuthenticatedAdminBlogIndexRoute
}

const AuthenticatedAdminBlogRouteWithChildren = AuthenticatedAdminBlogRoute._addFileChildren(AuthenticatedAdminBlogRouteChildren)



const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminBlogRoute: AuthenticatedAdminBlogRouteWithChildren,AuthenticatedAdminBusquedasRoute: AuthenticatedAdminBusquedasRoute,AuthenticatedAdminCalculadoraRoute: AuthenticatedAdminCalculadoraRoute,AuthenticatedAdminContactosRoute: AuthenticatedAdminContactosRoute,AuthenticatedAdminCrmRoute: AuthenticatedAdminCrmRoute,AuthenticatedAdminInfluencerRoute: AuthenticatedAdminInfluencerRoute,AuthenticatedAdminPerfilRoute: AuthenticatedAdminPerfilRoute,AuthenticatedAdminTareasRoute: AuthenticatedAdminTareasRoute,AuthenticatedAdminZubaRoute: AuthenticatedAdminZubaRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,AuthenticatedAdminPropiedadesIdRoute: AuthenticatedAdminPropiedadesIdRoute,AuthenticatedAdminPropiedadesNuevaRoute: AuthenticatedAdminPropiedadesNuevaRoute,AuthenticatedAdminPropiedadesIndexRoute: AuthenticatedAdminPropiedadesIndexRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const PublicOperationTypeRouteChildren = {
  PublicOperationTypeLocationRoute: PublicOperationTypeLocationRoute,PublicOperationTypeIndexRoute: PublicOperationTypeIndexRoute
}

const PublicOperationTypeRouteWithChildren = PublicOperationTypeRoute._addFileChildren(PublicOperationTypeRouteChildren)



const PublicRouteChildren = {
  PublicAgenteRoute: PublicAgenteRoute,PublicVendeTuPropiedadRoute: PublicVendeTuPropiedadRoute,PublicIndexRoute: PublicIndexRoute,PublicOperationTypeRoute: PublicOperationTypeRouteWithChildren,PublicBlogSlugRoute: PublicBlogSlugRoute,PublicPropiedadSlugRoute: PublicPropiedadSlugRoute,PublicProyectosSlugRoute: PublicProyectosSlugRoute,PublicBlogIndexRoute: PublicBlogIndexRoute,PublicProyectosIndexRoute: PublicProyectosIndexRoute
}

const PublicRouteWithChildren = PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,PublicRoute: PublicRouteWithChildren,AuthRoute: AuthRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)